<div [ngClass]="['alert-container', 'alert-' + type]">
  @if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  <span class="body-s">{{ text }}</span>
  @if (button !== '') {
    <app-button
      (click)="navigateToBasket()"
      type="secondary"
      size="small"
      [text]="button"></app-button>
  }
  @if (closeButton) {
    <mat-icon (click)="closeSnackBar()">close</mat-icon>
  }
</div>
